import moment from 'moment';

import { months } from 'src/components/date-of-birth-input/constants';

export function parseThirdPartyDOB(dobStr?: string) {
    if (!dobStr) return { day: '', month: '', year: '' };

    const parsed = moment(dobStr, 'DD-MM-YYYY', true);

    if (!parsed.isValid()) {
        return { day: '', month: '', year: '' };
    }

    const year = parsed.year();
    const currentYear = moment().year();

    if (year <= 1900 || year > currentYear) {
        return { day: '', month: '', year: '' };
    }

    return {
        day: String(parsed.date()),
        month: months[parsed.month()].value,
        year: String(year),
    };
}
